import React from "react"

import NavLink from "./NavLink"
import { NAV_ITEMS } from "../../constants/"

export default function NavList() {
    return (
        <section className="nav-list">
            {
                NAV_ITEMS.map(({ name }) => (
                    <NavLink key={name} name={name} classN="list-link" />
                ))
            }
        </section>
    )
}
